
export const regionCenters = {
  all: {
    center: [24.0, 45.0] as [number, number], // Center focused on Saudi Arabia
    zoom: 5 // Increased zoom to focus more on Saudi Arabia
  },
  Riyadh: {
    center: [24.7136, 46.6753] as [number, number],
    zoom: 11
  },
  Jeddah: {
    center: [21.4858, 39.1925] as [number, number],
    zoom: 11
  },
  Eastern: {
    center: [26.4282, 50.0888] as [number, number], // Dammam
    zoom: 10
  },
  Medina: {
    center: [24.5247, 39.5692] as [number, number],
    zoom: 11
  },
  Makkah: {
    center: [21.4225, 39.8262] as [number, number],
    zoom: 11
  },
  'Al Kharj': {
    center: [24.1293, 47.3348] as [number, number],
    zoom: 12
  },
  Dawadmi: {
    center: [24.5069, 44.3943] as [number, number],
    zoom: 12
  },
  Tabuk: {
    center: [28.3998, 36.5782] as [number, number],
    zoom: 11
  },
  Hail: {
    center: [27.5114, 41.6901] as [number, number],
    zoom: 11
  },
  'Hafar Al Batin': {
    center: [28.4329, 45.9700] as [number, number],
    zoom: 11
  },
  Majmaa: {
    center: [25.9114, 45.3700] as [number, number],
    zoom: 12
  },
  Qassim: {
    center: [26.3274, 43.9747] as [number, number], // Buraydah
    zoom: 11
  },
  Sakaka: {
    center: [29.9697, 40.2064] as [number, number],
    zoom: 11
  },
  'Ar\'ar': {
    center: [30.9753, 41.0381] as [number, number],
    zoom: 11
  },
  'Al Qurayyat': {
    center: [31.3319, 37.3417] as [number, number],
    zoom: 11
  },
  'Al Jubail': {
    center: [27.0174, 49.6583] as [number, number],
    zoom: 11
  },
  Yanbu: {
    center: [24.0896, 38.0618] as [number, number],
    zoom: 11
  },
  'Khamis Mushait': {
    center: [18.3059, 42.7322] as [number, number],
    zoom: 11
  },
  Sabia: {
    center: [17.1494, 42.6262] as [number, number],
    zoom: 11
  },
  Abha: {
    center: [18.2164, 42.5047] as [number, number],
    zoom: 11
  },
  Jizan: {
    center: [16.8892, 42.5511] as [number, number],
    zoom: 11
  },
  Najran: {
    center: [17.4917, 44.1319] as [number, number],
    zoom: 11
  },
  Muhayil: {
    center: [18.5167, 42.0333] as [number, number],
    zoom: 11
  },
  'Al Bahah': {
    center: [20.0129, 41.4677] as [number, number], // Al Baha coordinates
    zoom: 11
  }
};
